import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Row from '../Shows';
import Loading from './../Loading/index';
import useShows from "./service";
import './styles.css';
import logo from '../../logo.png';
import avatar from './avatar.png';
import { useAppSelector } from "../../core/hooks";

const Dashboard = () => {

    const userName = useAppSelector(state => state.user.name);

    const { isLoading, mainShow, shows } = useShows();
    if (isLoading) {
        return <Loading />;
    }


    return (
        <div className="dashborad__wrapper">
            <header>
                <div className="logo">
                    <img className="fluid-img" src={logo} alt="App Logo" />
                </div>
                <div className="dashboard__profile">
                    <img className="fluid-img" src={avatar} alt="Avatar" />
                    <span className="dashborad__profile__name">{userName}</span>
                </div>
            </header>
            <div className="dashborad__hero">
                <div className="dashborad__hero-image-wrapper">
                    <img className="fluid-img" src={`${process.env.REACT_APP_IMAGE_BASE_URL}/original${mainShow?.backdrop_path}`} alt="Landing Hero" />
                    <div className="dashborad__hero-img-gradient"></div>
                </div>
                <div className="dashborad__hero-content-wrapper">
                    <h1 className="dashborad__hero-title">{mainShow.title || mainShow.name}</h1>
                    <p className="dashboard__overview">{mainShow.overview}</p>
                    <button className="dashborad__button"><FontAwesomeIcon icon={faPlay} size="sm" /> &nbsp; Play</button>
                </div>
            </div>
            <div className="dashborad__below-fold">
                {shows.map((row: { shows: any; title: any; }, index: any) => (
                    <Row key={index} index={index} shows={row.shows} title={row.title} />
                ))}
            </div>
        </div>
    );
};

export default Dashboard;